import type { Configuration } from '@azure/msal-browser';

const clientId = import.meta.env.VITE_AZURE_CLIENT_ID as string | undefined;
const tenantId = import.meta.env.VITE_AZURE_TENANT_ID as string | undefined;

// Guard against both empty AND undefined — an absent .env leaves these
// undefined, which would otherwise bake `authority=.../undefined` into the
// bundle and fail every login with AADSTS900023 at runtime.
if (clientId === undefined || clientId === '' || tenantId === undefined || tenantId === '') {
  throw new Error(
    'Missing Azure AD configuration. Set VITE_AZURE_CLIENT_ID and VITE_AZURE_TENANT_ID in .env',
  );
}

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

/**
 * Separate request used to silently acquire a delegated Graph access
 * token after login. User.Read is default-consented for every signed-in
 * user in the tenant, so no admin approval is needed.
 */
export const graphRequest = {
  scopes: ['User.Read'],
};

/**
 * Token request for tenant directory user search (displayName typeahead).
 * User.ReadBasic.All requires admin consent — granted by IT on 2026-04-15.
 * Kept separate from graphRequest so adding this scope cannot affect the
 * existing /me provisioning flow.
 */
export const graphSearchRequest = {
  scopes: ['User.ReadBasic.All'],
};

/**
 * Token request for location-scoped employee roster queries.
 * User.Read.All requires admin consent — granted by IT on 2026-04-15.
 * Needed to read companyName on other users, which is not in the basic
 * profile set exposed by User.ReadBasic.All.
 */
export const graphLocationRequest = {
  scopes: ['User.Read.All'],
};
